import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { toWeekStartDate } from '../../../helpers/moment';

const BrUpload = ({
  showModal,
  showAdditionalModal,
  activeView,
  toggleView,
  activeWeek,
  activeClient,
  activeSite,
}) => {
  const type = localStorage.getItem('type');

  let startWeek = toWeekStartDate(moment(), activeClient.start_day);
  let activeClass = 'btn btn-brand';
  let inactiveClass = 'btn btn-outline-brand';
  return (
    <React.Fragment>
      {type !== 'client' &&
        moment(activeWeek.startDate).isSameOrAfter(
          startWeek.subtract(1, 'days')
        ) && (
          <div
            className="adjust-card-shadow mb-4 px-4 d-flex flex-row justify-content-between align-items-center dropdown custom-dropdown"
            style={{
              height: '120px',
              borderLeft: ' 10px solid #bee10e',
              marginRight: '1rem',
            }}
          >
            <div className="d-flex flex-column" style={{ width: '70%' }}>
              <h6 className="adjust-upload-title">Headcount Upload</h6>
              <p className="text-muted adjust-upload-description">
                Upload weekly allocation
              </p>
            </div>
            <button
              type="button"
              className="btn btn-outline-brand dropdown-toggle adjust-btn-shadow px-4"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Upload
            </button>
            <div
              className="dropdown-menu dropdown-menu-right mt-2"
              style={{ width: '200px' }}
              aria-labelledby="dropdownMenuButton"
            >
              <span onClick={showModal} className="dropdown-item">
                Required
              </span>
              {/* <span 
              onClick={showAdditionalModal} 
              className="dropdown-item">
                Additional
              </span> */}
            </div>
          </div>
        )}
    </React.Fragment>
  );
};

export default BrUpload;
